module.exports = __webpack_public_path__ + "static/media/socicon.739b516e.woff";